import { render, staticRenderFns } from "./specialCollectionList.vue?vue&type=template&id=0c318e04"
import script from "./specialCollectionList.vue?vue&type=script&lang=js"
export * from "./specialCollectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports